import { render, staticRenderFns } from "./ManualReorder.vue?vue&type=template&id=0aa5ee73"
import script from "./ManualReorder.vue?vue&type=script&lang=ts"
export * from "./ManualReorder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports